import PropTypes from 'prop-types'
import React from 'react'
import TextField from '../../molecules/fields/TextField'
import Alert from '../../molecules/Alert'
import QuestionOptionsSection from './QuestionOptionsSection'

const DateField = ({ baseName, validate }) => {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <span>
        <TextField
          label="Etiqueta de la pregunta"
          margin="none"
          size="full"
          name={`${baseName}.payload.label`}
          validate={validate}
          errorClassName="relative inset-0"
          initialValue=""
          capsLockInfo
        />
        <QuestionOptionsSection baseName={baseName} margin="none" size="full" />
      </span>
      <Alert type="info">Las personas verán un selector de fechas con el formato DD/MM/AA.</Alert>
    </div>
  )
}

export default DateField

DateField.propTypes = {
  baseName: PropTypes.string,
  validate: PropTypes.func
}
